var inputStyle = {"z-input":"z-input","z-input--has-icon":"z-input--has-icon","z-input-icon":"z-input-icon"};

export { inputStyle as default };
//# sourceMappingURL=Input.module.scss.js.map
